import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Upload } from 'app/uploads/shared/upload';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { UserService } from 'app/users/shared/user.service';
import { DateService } from 'app/date/date.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';

@Component({
  selector: 'app-manage-admin',
  templateUrl: './manage-admin.component.html',
  styleUrls: ['./manage-admin.component.css'],
  providers:[NotificationToastService, AngularFireDatabase, DateService]
})
export class ManageAdminComponent implements OnInit {
  private myForm: FormGroup;
  private userId:string;
  private imageToUpload = "assets/images/avatar-4.png";
  submitted : boolean = false;
  hasError : boolean ;
  selectedFiles: FileList;
  currentUpload: Upload;
  hasFile: Boolean = false;
  private basePath:string = '/uploads';
  private image;
  editProfile = true;
  editProfileIcon = 'icofont-edit';
  userData : Observable<any>;
  user: any;
  branches:any;
  constructor(private route: ActivatedRoute, public db:AngularFireDatabase, private nf: NotificationToastService, private userService:UserService, private dateServcie:DateService) {
    var data = this.route.snapshot.queryParamMap.get('key');
    this.userId = data;
    this.initializeForm();
   }

  ngOnInit() {
    this.getUser();
  }

  initializeForm()
  {
    let name = new FormControl('', Validators.required);
    let email = new FormControl('', [Validators.required,Validators.email]);
    let phone = new FormControl('', [Validators.required, ,Validators.maxLength(12)]);
    let branch = new FormControl('Select Branch', Validators.required);
    let code = new FormControl('',Validators.required);

    this.myForm = new FormGroup({
      name:name,
      email:email,
      code: code,
      phone: phone,
      branch: branch
    });
    var branches = this.userService.getAllBranches();
    branches.snapshotChanges().subscribe(item=>{
      this.branches = [];
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.branches.push(y);
      });
    });
    this.myForm.reset();
    this.edit();
  }
  private edit()
  {
    this.db.object('/users/' + this.userId)
    .subscribe(admin =>{
      let name = new FormControl(admin.name, Validators.required);
      let email = new FormControl(admin.email, [Validators.required,Validators.email]);
      let code = new FormControl(admin.code,Validators.required);
      let phone = new FormControl(admin.phoneNumber, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]);
      let branch = new FormControl(admin.branch, Validators.required);
      if(admin.profilePic)
      this.imageToUpload = admin.profilePic;
       // Assuming that name is a value of customer you can say
       this.myForm = new FormGroup({
        name:name,
        email:email,
        code: code,
        phone: phone,
        branch: branch
      });
      if(admin.code == "+966")
      {
        this.maxLength = 9;
        this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      }
      else
      {
        this.maxLength = 10;
        this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      }
    });
    
  } 
  phone_error:boolean = false;
  onSubmit()
  {
    this.hasError = false;
    this.submitted = true;
    this.phone_error = false;
    var phone = this.myForm.value.phone;
    if(phone.length != this.maxLength){
      this.phone_error = true;
      return;
    }
    else if(this.myForm.valid) {
      var phone = this.myForm.value.phone1;
      var date_time =  this.dateServcie.getTimeandDate();
      var usersRef = firebase.database().ref("users");
      usersRef.child(this.userId).update({
        name: this.myForm.value.name,
        email: this.myForm.value.email,
        code: this.myForm.value.code,
        phoneNumber: this.myForm.value.phone,
        branch: this.myForm.value.branch,
        updatedAt: date_time.date,
        updatedTime: date_time.time
      }).then(
        (success) => {
          this.submitted = false;
          this.myForm.reset();
          this.currentUpload = null;
          this.nf.addToast({title:'Update Success', msg:'Admin data has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});   
          this.toggleEditProfile(); 
        });
    } 
  }
  toggleEditProfile() {
    this.editProfileIcon = (this.editProfileIcon === 'icofont-close') ? 'icofont-edit' : 'icofont-close';
    this.editProfile = !this.editProfile;
    if(this.editProfileIcon == 'icofont-edit')
    this.edit();
  }
  public getUser(){
    this.userData = this.db.object("users/"+this.userId);
    this.userData.subscribe(user=>{
      this.getBranchName(user.branch);
      this.user = user;
      if(user.imageUrl !=null)
      this.imageToUpload = user.imageUrl;
    });
  }
  func(){
    this.image = "assets/images/avatar-4.png";
    this.hasFile = false;
  }
  detectFiles(event) {
    this.hasFile = true;
    this.selectedFiles = event.target.files;
    this.readUrl(event);
  }
  readUrl(event:any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event:any) => {
        this.image = event.target.result;
        this.imageToUpload = event.target.result;
      } 
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  uploadPhoto()
  {  
  if(this.hasFile && this.selectedFiles.length!=0)
  {
    let file = this.selectedFiles.item(0);
    this.currentUpload = new Upload(file);

    let storageRef = firebase.storage().ref();
    let uploadTask = storageRef.child(`${this.basePath}/${"profileImages"}/${this.userId}`).put(this.currentUpload.file);

  uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) =>  {
      // upload in progress
      this.currentUpload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100;
    },
    (error) => {
      // upload failed
      //console.log(error)
    },
    () => {
      // upload success
      this.currentUpload.url = uploadTask.snapshot.downloadURL;
      this.currentUpload.name = this.currentUpload.file.name;
      var usersRef = firebase.database().ref("users");
      usersRef.child(this.userId).update({ 
        imageUrl: this.currentUpload.url
      }).then(
        (success) => {
          this.currentUpload = null;
          this.hasFile = false;
          this.image = "assets/images/avatar-4.png";
          this.getUser();
          this.nf.addToast({title:'Update Success', msg:'Profile Photo has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});    
        });
    });
    }
  }
  getBranchName(branchid)
  {
    if(branchid!=null)
    {
      firebase.database().ref("branches").child(branchid).once("value").then((branch)=>{
        this.user.branch = branch.child("name").val();
      });
    }
  }
  keyPressUserName(event)
  {
    var format = /[a-zA-Z0-9-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !format.test(inputChar)) {
      event.preventDefault();
    }
  }
  maxLength: number =9;
  onChangeCountry(e)
  {
    this.phone_error = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength  = 10;
      this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      break;
      case "+966" : this.maxLength  = 9;
      this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      break;
    }
  }
  public keyPress(event: any) {
    this.phone_error = false;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone = this.myForm.value.phone;
      if(phone.length >= this.maxLength)
      {
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/admins/manage-admin/manage-admin.component.ts